import { api } from "./api";

export interface ApostilaPatente {
  apostila_id: string;
  patente_id: string;
  pode_editar: boolean;
  patente: {
    id: string;
    patente: string;
    abreviacao?: string;
    categoria?: string;
    ordem: number;
  };
}

export interface Apostila {
  id: string;
  titulo: string;
  descricao: string | null;
  conteudo_html: string;
  publicado: boolean;
  ordem: number;
  categoria_id: string | null;
  categoria?: { id: string; nome: string; ordem: number } | null;
  apostilaPatentes?: ApostilaPatente[];
  criado_em: string;
  alterado_em: string;
}

export interface CreateApostilaData {
  titulo: string;
  descricao?: string;
  conteudo_html?: string;
  publicado?: boolean;
  ordem?: number;
  categoria_id?: string;
  patentes_visualizar?: string[];
  patentes_editar?: string[];
}

export interface UpdateApostilaData {
  titulo?: string;
  descricao?: string;
  conteudo_html?: string;
  publicado?: boolean;
  ordem?: number;
  categoria_id?: string | null;
  patentes_visualizar?: string[];
  patentes_editar?: string[];
}

export interface ReordenarApostilasData {
  ordens: Array<{ id: string; ordem: number }>;
}

class ApostilasService {
  async list(): Promise<Apostila[]> {
    const response = await api.get("/apostilas");
    return response.data;
  }

  async listPainel(): Promise<Apostila[]> {
    const response = await api.get("/apostilas/painel");
    return response.data;
  }

  async create(data: CreateApostilaData): Promise<Apostila> {
    const response = await api.post("/apostilas", data);
    return response.data;
  }

  async update(id: string, data: UpdateApostilaData): Promise<Apostila> {
    const response = await api.put(`/apostilas/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/apostilas/${id}`);
  }

  async reordenar(data: ReordenarApostilasData): Promise<void> {
    await api.put("/apostilas/reordenar", data);
  }
}

export const apostilasService = new ApostilasService();
